<!--<header>-->
<!--  <h1>{{(header) | translate}}</h1>-->
<!--  <mat-icon id="close-button" mat-dialog-close>close</mat-icon>-->
<!--</header>-->

<!--<mat-divider></mat-divider>-->
<!--<div class="modal-body">-->
<!--  <span>{{text | translate}} </span>-->
<!--</div>-->
<!--<mat-divider></mat-divider>-->

<app-modal
  [title]="header | translate"
  [cancelButtonExists]="false"
  [isDataLoaded]="true"
  saveButtonName="DIALOG.OK"
  (save)="acknowledged()"
>
  <ng-container body>
    <span>{{ text | translate }} </span>
  </ng-container>
</app-modal>
